export enum ContentHomeTicketButtonType {
  Ticket = 'Ticket',
  Refund = 'Refund',
  Gift = 'Gift',
  StopText = 'StopText',
}
